import React from "react"
import { useInView } from 'react-intersection-observer';
import './animations.css';
import map_station from "../Assets/map_station.png";

import { Link } from "react-router-dom";

const Aboutus = () => {
    
    
    const { ref, inView } = useInView({
        triggerOnce: true, // Trigger animation only once
        threshold: 0.1, // Adjust based on when you want the animation to start
    });
    return (
        <div className="bg-[#6ab615] text-white w-full py-8 px-2 md:px-10 lg:px-16">
           <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="w-full md:w-[700px]">
                    <h2 className="text-xl font-bold">ABOUT US</h2>
                    <h2
                     ref={ref}
                     className={`transition-opacity duration-1000 ease-in-out text-2xl my-6 font-yatra ${inView ? 'slide-in-from-left' : 'opacity-0'}`}>Professional solution to Enhance Living </h2>
                    <p>Electromob is poised to revolutionize electric mobility in Nigeria by Undertaking an ambitous plan to deploy electric
                        vehicle charging stations across the nation. With a commitment to sustainable transportation solutions, our goal is to 
                        pave the way for a cleaner and greener future. Our phased approach reflects our dedication to making electric
                        mobility accesible to all, while contributing to the overall development of Nigeria's infrastructure
                    </p>
                    {/* <Link to="/Aboutusp">
                        <button className="bg-transparent backdrop-blur-md backdrop-brightness-75 text-white px-4 py-2 rounded-lg mt-4 font-luckiest">READ MORE</button>
                    </Link> */}
                    <Link to="/">
                        <button className="bg-transparent backdrop-blur-md backdrop-brightness-75 text-white px-4 py-2 rounded-lg mt-4 font-luckiest">READ MORE</button>
                    </Link>
                    
                </div>
                <div
                   ref={ref}
                   className={`transition-opacity duration-1000 ease-in-out flex justify-end w-full mt-16 md:mt-0 ${inView ? 'slide-in-from-bottom' : 'opacity-0'}`}>
                    <img src={map_station}  alt="img" className="w-full object-contain md:w-[400px]  rounded-md" />
                </div>
           </div>
        </div>
    )
}

export default Aboutus;